import { CardListItem } from "@amzn/storm-ui";
import React from "react";
import { Page } from "react-pdf";
import styled from "styled-components";

import SkeletonLoader from "./SkeletonLoader";

export interface PdfSelectorProps {
    index: number;
    width: number;
    selectedSlides: Set<number>;
    setSelectedSlides: (selectedslides: Set<number>) => void;
    isCompliant: boolean;
}

const PdfSelectorPageContainer = styled.div<{ isCompliant: boolean }>`
    cursor: ${(props) => (props.isCompliant ? "pointer" : "default")};
    display: flex;
    justify-content: center;
`;

export const PdfSelector: React.FunctionComponent<PdfSelectorProps> = (
    props: PdfSelectorProps,
) => {
    const { index, width, selectedSlides, setSelectedSlides, isCompliant } =
        props;

    const selected = selectedSlides.has(index);

    const pdfScale: number = 0.75;

    const handleChange = () => {
        const newSelectedSlides = new Set(selectedSlides);
        if (!selected) {
            newSelectedSlides.add(index);
        } else {
            newSelectedSlides.delete(index);
        }
        setSelectedSlides(newSelectedSlides);
    };

    const onSelect = isCompliant ? () => handleChange() : undefined;

    return (
        <CardListItem
            id={`pdf-selector-${index}`}
            ariaLabel=""
            onSelect={onSelect}
            isSelected={selected}
            onFooterClick={onSelect}
            footer={<div>{index + 1}</div>}
        >
            <PdfSelectorPageContainer isCompliant={isCompliant}>
                <Page
                    onClick={onSelect}
                    data-testid={`pdf-viewer-page-${index}`}
                    loading={
                        <SkeletonLoader
                            height="200px"
                            width={`${(width * pdfScale).toString()}px`}
                        />
                    }
                    key={`page_${index + 1}`}
                    pageNumber={index + 1}
                    scale={pdfScale}
                    width={width}
                    renderAnnotationLayer={false}
                    renderTextLayer={false}
                />
            </PdfSelectorPageContainer>
        </CardListItem>
    );
};
